import React from "react";

// Components
import Image from "../images/image";

function Navigation() {
    return (
        <nav className="navigation container flex flex-align flex-space">
            <Image
                height="100%"
                className="navigation-banner"
                src={`${process.env.PUBLIC_URL}/logo/logo-eurus.jpg`}
            />
            <Image
                height="64px"
                width="64px"
                src={`${process.env.PUBLIC_URL}/logos/Logo - Baas boven Baas_1@4x.png`}
            />
        </nav>
    );
}

export default Navigation;
